import type { IAssetsLoader } from '../../AssetLoader/IAssetsLoader';
import type { ICompositor } from '../../Compositor/ICompositor';
import { type ImageModel } from '../../Models/Models/ImageModel';
import { BaseRenderer } from '../BaseRenderer/BaseRenderer';

export class ImageRenderer extends BaseRenderer {
    constructor(imageModel: ImageModel, assetLoader: IAssetsLoader, compositor: ICompositor) {
        super(imageModel, assetLoader, compositor);
    }

    private handleCompModelUpdate = () => this.redrawCompModel();

    async init() {
        super.init();
        const compModel = this.creativeModel.getCompModel();
        this.getCreativeModel().eventEmitter.on('requireCreativeUpdate', this.handleCompModelUpdate);

        // drawing comp model takes time (especially when the tab is not active),
        // all the subscription should be done before drawing
        await this.drawCompModel(compModel);
    }

    redraw() {
        this.redrawCompModel();
    }

    private async redrawCompModel() {
        await this.drawCompModel(this.creativeModel.getCompModel());
    }

    zoomToFit() {
        const dimension = this.compositor.getCompositorWrapperDimension();
        const creativeDimension = this.creativeModel.getDimensions();
        const scaleX = dimension.getWidth() / creativeDimension.getWidth();
        const scaleY = dimension.getHeight() / creativeDimension.getHeight();
        const scale = Math.min(scaleX, scaleY);

        this.setScale(scale);
    }
}
